import type { ReactNode } from "react";
import cnBind from "classnames/bind";
import type { ButtonProps } from "primereact/button";
import { Button as PrimeButton } from "primereact/button";

import { TelegramIcon } from "@/shared/assests/svg/svg";

import styles from "./Button.module.scss";

export type ButtonVariants = "outlined" | "white" | "solid";

const cx = cnBind.bind(styles);

export interface UIButtonProps extends ButtonProps {
    variant?: ButtonVariants;
    isFullWidth?: boolean;
    iconTrue?: boolean;
    size?: "small" | "large";
    icon?: ReactNode;
}

export const Button = ({
    variant = "white",
    type = "button",
    iconTrue = true,
    size = "large",
    className,
    isFullWidth,
    icon,
    ...props
}: UIButtonProps) => {
    const resolvedIcon = icon ?? (iconTrue ? <TelegramIcon className={cx("icon")} /> : undefined);

    return (
        <PrimeButton
            type={type}
            className={cx("ui-button", className, variant, { isFullWidth }, { iconTrue: Boolean(resolvedIcon) }, size)}
            icon={resolvedIcon}
            {...props}
        />
    );
};
